import { render, staticRenderFns } from "./weightUnit.vue?vue&type=template&id=50941a52&scoped=true&"
import script from "./weightUnit.vue?vue&type=script&lang=js&"
export * from "./weightUnit.vue?vue&type=script&lang=js&"
import style0 from "./weightUnit.vue?vue&type=style&index=0&id=50941a52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50941a52",
  null
  
)

export default component.exports